import type { FC } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Checkbox, Link } from "@aviary";
import { sharedRoutes } from "@shared/data/sharedRoutes";
import { l } from "@unauthenticated/shared/locales/i18n";

interface Props {
  updateTimestamp: (date: Date | "") => void;
  isChecked?: boolean;
  isEmerson?: boolean;
}

const TermsOfServiceCheckbox: FC<Props> = ({ isEmerson, updateTimestamp, isChecked }) => {
  const { t } = useTranslation();

  const platform = isEmerson ? t(l.common.EmersonEcologics) : t(l.common.Fullscript);
  const route = isEmerson ? sharedRoutes.external.emersonTerms : sharedRoutes.external;

  const handleCheckboxClick = e => {
    if (e.target.checked) {
      const date = new Date();
      updateTimestamp(date);
    } else {
      updateTimestamp("");
    }
  };

  return (
    <Checkbox data-e2e="tos_checkbox" onClick={handleCheckboxClick} defaultChecked={isChecked}>
      <Trans i18nKey={l.common.Terms}>
        I agree to {{ platform }}'s
        <Link href={route.termsOfService} noExternalIcon>
          Terms of Service
        </Link>
        and
        <Link href={route.privacyPolicy} noExternalIcon>
          Privacy Statement
        </Link>
      </Trans>
    </Checkbox>
  );
};

export { TermsOfServiceCheckbox };
